export default "__VITE_ASSET__CpO_Us19__"